<template>
  <div class="g-header__base-header">
    <div
      :class="['g-header__base-logo', { 'g-header__logo--hide': logoHidden }]"
    >
      <a :aria-label="logoAriaText" :href="baseUrl" tabindex="0">
        <JPCAHeaderLogo />
      </a>
    </div>
    <nav
      class="g-header__base-nav"
      role="navigation"
      :aria-label="navAriaLabel"
    >
      <ListOfLinks :links="items" />
    </nav>
  </div>
</template>

<script>
import { ListOfLinks, useLocalization } from "@thegetty-private/getty-ui";
import JPCAHeaderLogo from "@/components/atoms/jpcaHeaderLogo/index.vue";
export default {
  name: "BaseHeader",
  components: {
    JPCAHeaderLogo,
    ListOfLinks
  },
  props: {
    /**
     * Header logo href
     */
    baseUrl: {
      type: String,
      default: "/"
    },
    /**
     * Array of objects to display as the base navigation
     */
    items: {
      type: Array,
      default: null
    },
    /**
     * Whether the logo should be shown
     */
    logoHidden: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * Aria labels from the Base header
       */
      logoAriaText: this.translatePart("g-jpca-header.base_logo_aria_label"),
      navAriaLabel: this.translatePart("g-jpca-header.base_nav_aria_label")
    };
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
